/* eslint-disable */
import { types } from 'mobx-state-tree';
import BusinessOpportunities from '../BusinessOpportunities';
import Community from '../Community';
import Company from '../Company';
import Compose from '../Compose';
import Contact from '../Contact';
import Context from '../Context';
import SavedTab from '../SavedTab';
import Search from '../Search';
import Ugc from '../ugc/index';
import User from '../User';
import UserSettings from '../UserSettings';
import WishlistCard from '../WishlistCard';
import Actions from './Actions';
import Views from './Views';
import SearchFiltersModel from '../SearchFilters/SearchFiltersModel';
import OnDemand from '../onDemand';
import SaveToCrm from '../SaveToCrm';
import FreeTrailDecisionPopup from '../FreeTrailDecisionPopup';
import Pricing from '../Pricing';
import UserActivity from '../UserActivity';
const StoreProps = {
    isInitialized: types.optional(types.boolean, false),
    user: types.optional(User, () => User.create()),
    compose: types.optional(Compose, () => Compose.create()),
    userSettings: types.optional(UserSettings, () => UserSettings.create()),
    context: types.optional(Context, () => Context.create()),
    companies: types.map(Company),
    community: types.optional(Community, () => Community.create()),
    contextCompany: types.maybe(Company),
    contextContact: types.maybe(Contact),
    prospecting: types.maybe(Search),
    searchedCompany: types.maybe(Company),
    employee: types.maybe(Contact),
    search: types.maybe(Search),
    businessOpportunities: types.optional(BusinessOpportunities, () => BusinessOpportunities.create()),
    savedTab: types.optional(SavedTab, () => SavedTab.create()),
    ugc: types.optional(Ugc, () => Ugc.create()),
    wishlistCard: types.optional(WishlistCard, () => WishlistCard.create()),
    searchFilters: types.optional(SearchFiltersModel, () => SearchFiltersModel.create()),
    onDemand: types.optional(OnDemand, () => OnDemand.create()),
    saveToCrm: types.optional(SaveToCrm, () => SaveToCrm.create()),
    freeTrialDecisionPopup: types.optional(FreeTrailDecisionPopup, () => FreeTrailDecisionPopup.create()),
    userActivity: types.optional(UserActivity, () => UserActivity.create()),
    pricing: types.optional(Pricing, () => Pricing.create()),
    accountCreditsTypes: types.optional(types.array(types.frozen()), []),
    totalCredits: types.optional(types.integer, 0),
    userPlanTotalCredits: types.optional(types.integer, 0),
};
const RootStoreModel = types.model(StoreProps).actions(Actions).views(Views);
const rootStore = RootStoreModel.create({});
export default rootStore;
export { RootStoreModel };
